import { Input } from 'govwell-ui'

import { Size } from '../../../govwell-ui/types'
import { TanstackField } from '../../../utils/forms'

export type InputFieldProps<TKey extends string> = {
  ariaLabel?: string
  autoFocus?: boolean
  isClearable?: boolean
  isReadOnly?: boolean
  caption?: React.ReactNode
  errorMessage?: React.ReactNode
  field: TanstackField<string, TKey>
  isInvalid?: boolean
  isRequired?: boolean
  label?: React.ReactNode
  placeholder?: string
  size?: Size
  width?: React.CSSProperties['width']
}
const InputField = <TKey extends string>({
  ariaLabel,
  autoFocus,
  isClearable,
  isReadOnly,
  caption,
  errorMessage: propErrorMessage,
  field,
  isInvalid: propIsInvalid,
  isRequired,
  label,
  placeholder,
  size,
  width,
}: InputFieldProps<TKey>) => {
  const errorMessage = propErrorMessage || field.state.meta.errors.join(', ')
  const isInvalid = propIsInvalid || !!errorMessage
  return (
    <Input
      {...(label ? { label } : { ariaLabel: ariaLabel || '' })}
      autoFocus={autoFocus}
      caption={caption}
      errorMessage={errorMessage}
      isClearable={isClearable}
      isReadOnly={isReadOnly}
      isInvalid={isInvalid}
      isRequired={isRequired}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      placeholder={placeholder}
      size={size}
      value={field.state.value}
      width={width}
    />
  )
}

export default InputField
